import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Topnav } from './navigation/topnav';
import { TeacherOverviewPage } from './pages/teacher/TeacherOverviewPage/TeacherOverviewPage';
import LoginPage from './pages/LoginPage/LoginPage';
import LandingPage from './pages/LandingPage/LandingPage';
import { ProtectedRoute } from './components/common/ProtectedRoute/ProtectedRoute';
import TeacherClasses from './pages/teacher/TeacherClasses';
import { ExercisePage } from './pages/ExercisePage/ExercisePage';
import { ExerciseOverviewPage } from './pages/ExerciseOverviewPage/ExerciseOverviewPage';
import { ExerciseGeneratorPage } from './pages/ExerciseGeneratorPage';
import { SnackbarProvider } from './navigation/snackbar';
import { AuthProvider } from './app/auth/AuthContext';
import { ExerciseAttemptPage } from './pages/ExerciseAttemptPage/ExerciseAttemptPage';
import EventsPage from './pages/EventsPage/EventsPage';

function App() {
  return (
    <AuthProvider>
      <SnackbarProvider>
        <Router>
          <div className="App">
            <Topnav />
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<LoginPage />} />

              <Route
                path="/docent/klassen"
                element={
                  <ProtectedRoute scope="TEACHER">
                    <TeacherClasses />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/docent/overzicht"
                element={
                  <ProtectedRoute scope="TEACHER">
                    <TeacherOverviewPage />
                  </ProtectedRoute>
                }
              />

              <Route path="/opdrachten" element={<ExerciseOverviewPage />} />
              <Route
                path="/opdrachten/genereren"
                element={
                  <ProtectedRoute scope="ADMIN">
                    <ExerciseGeneratorPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/opdrachten/nieuw"
                element={
                  <ProtectedRoute scope="ADMIN">
                    <ExercisePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/opdrachten/:id"
                element={
                  <ProtectedRoute scope="ADMIN">
                    <ExercisePage />
                  </ProtectedRoute>
                }
              />
              <Route path="/opdrachten/:id/poging" element={<ExerciseAttemptPage />} />
              <Route path="/kalender" element={<EventsPage />} />
            </Routes>
          </div>
        </Router>
      </SnackbarProvider>
    </AuthProvider>
  );
}

export default App;
